/* eslint-disable no-console, @typescript-eslint/no-explicit-any */
const __DEV__ = process.env.NODE_ENV !== 'production'; // eslint-disable-line no-underscore-dangle
const Console = {
    deprecate: console.warn,
    debug: console.debug,
    error: console.error,
    info: console.info,
    log: console.log,
    warn: console.warn,
    table: console.table,
    trace: console.trace,
    group: console.group,
    groupCollapsed: console.groupCollapsed,
    groupEnd: console.groupEnd,
    clear: console.clear,
    count: console.count,
    assert: console.assert,
};
const log = (key, ...args) => {
    if (__DEV__) {
        Console[key](...args);
    }
};
export default {
    deprecate: (...args) => log('deprecate', 'DeprecationWarning:', ...args),
    debug: (...args) => log('debug', ...args),
    error: (...args) => log('error', ...args),
    info: (...args) => log('info', ...args),
    log: (...args) => log('log', ...args),
    warn: (...args) => log('warn', ...args),
    table: (...args) => log('table', ...args),
    trace: (...args) => log('trace', ...args),
    group: (...args) => log('group', ...args),
    groupCollapsed: (...args) => log('groupCollapsed', ...args),
    groupEnd: (...args) => log('groupEnd', ...args),
    clear: (...args) => log('clear', ...args),
    count: (...args) => log('count', ...args),
    assert: (...args) => log('assert', ...args),
};
//# sourceMappingURL=index.js.map